import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {
  KeyboardDatePicker,
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Chip from "@material-ui/core/Chip";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

class EditableDatagridCell extends React.Component {
  constructor(props) {
    super(props);
    this.colDefValidation(props.cellInfo.colDef);
    this.state = {
      valueFromPromise: null,
      isError: false,
      inputErrorMsg: null,
      fieldResetKey: { key: Date.now() },
      showPassword: false,
      lastValue: null,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    var i = this.props.cellInfo;
    var type = i.colDef.dataType;
    if (type === "text" || type === "number") {
      var field = i.colDef.field;
      var value = i.row[field];
      if (this.state.lastValue !== value) {
        this.setState({
          fieldResetKey: { key: Date.now() },
          lastValue: value,
        });
      }
    }
  }

  onChangeHandler(info, evt, type, values = []) {
    var { row } = info;
    var field = info.colDef.field;
    var value;
    if (type === "datetime") {
      value = evt && evt.getTime();
      if (info.colDef.postgresSQLTimestamp) value = value && value / 1000;
    } else if (type === "combobox") value = evt;
    else if (type === "list") {
      value = "";
      if (evt.length > 0) {
        var lastItem = evt.pop();
        var lastItemArray = lastItem
          .split(info.colDef.separator)
          .map((i) => i.trim());
        value = [...evt, ...lastItemArray].join(info.colDef.separator);
      }
    } else {
      value = evt.target.value;
      this.setState({ lastValue: value });
    }
    if (type === "number" && !this.props.addAsCell) {
      var { min, max } =
        this.props.cellInfo.colDef?.materialUiProps?.inputProps || {};
      min = min || 0;
      max = max || Infinity;
      var val = value;
      val = parseInt(val);
      value = isNaN(val) ? min : val > max ? max : val < min ? min : val;
      this.setState({ fieldResetKey: { key: Date.now() } });
    }
    //if (typeof value === "string") value = value.trim();
    if (this.state.isError || value !== row[field] || type === "number") {
      var pass = this.fieldValidation(info, value);
      !pass && evt.target.focus && setTimeout(() => evt.target.focus(), 100);
      pass && this.props.onChange(field, value, values);
    }
  }

  fieldValidation(info, value) {
    var pass = !info.colDef.inputRule || info.colDef.inputRule(info.row, value);
    this.setState({
      isError: !pass,
      inputErrorMsg: !pass && info.colDef.inputRuleMsg,
    });
    return pass;
  }

  colDefValidation(def) {
    if (def.dataType === "combobox") {
      if (def.freeText && def.labelKey)
        throw new Error(
          "For 'free text' combo box, the options must be a string array"
        );
    }
  }
  fetchDropdownList(i) {
    if (i.colDef.getValueFrom) {
      if (i.colDef.cacheValues && i.colDef.cachedValues) {
        this.setState({ valueFromPromise: i.colDef.cachedValues });
        return;
      }
      i.colDef.getValueFrom(i.row).then((values) => {
        i.colDef.cachedValues = values;
        this.setState({ valueFromPromise: values });
      });
    }
  }
  render() {
    var i = this.props.cellInfo;
    var isError = !!(this.props.error || this.state.isError);
    var field = i.colDef.field;
    var value = i.row[field];
    var type = i.colDef.dataType;
    type = type === "dateTime" ? "datetime-local" : type;
    var disabled = this.props.disabled || i.colDef.disabled;
    disabled = typeof disabled === "function" ? disabled(i.row) : disabled;
    var element = null;
    var valuesType = typeof i.colDef.values;
    var values =
      valuesType === "function" ? i.colDef.values(i) : i.colDef.values;
    var multilineProps =
      type === "text" && i.colDef.multiline
        ? {
            multiline: true,
            maxRows: 4,
          }
        : {};
    if (type === "text" || type === "number")
      element = (
        <TextField
          {...multilineProps}
          key={this.props.cellInfo.key}
          error={isError}
          type={type}
          variant="outlined"
          fullWidth={true}
          value={typeof value === "undefined" ? i.colDef.defaultValue : value}
          onClick={(e) => {
            // Fix for firefox's number input
            if (type === "number") {
              if (e.target.value !== value) this.onChangeHandler(i, e, type);
              e.target.select && e.target.select();
            }
          }}
          onChange={(e) => {
            this.onChangeHandler(i, e, type);
          }}
          onBlur={(e) => {
            this.onChangeHandler(i, e, type);
          }}
          onKeyPress={(e) => {
            // console.log(e)
            if (e.key === "Enter") {
              if (this.props.onEnterKeyPress) this.props.onEnterKeyPress();
              this.onChangeHandler(i, e, type);
            }
          }}
          disabled={!!disabled}
          inputProps={{
            min: i.colDef.minNum || 0,
            style: { ...this.props.style },
          }}
          placeholder={i.colDef.hint}
          {...i.colDef.materialUiProps}
        />
      );
    else if (
      type === "dropdown" ||
      (this.props.addAsCell && type === "radiogroup")
    ) {
      element = (
        <Select
          id={this.props.cellInfo.key}
          key={this.props.cellInfo.key}
          error={isError}
          style={{ width: "100%", ...this.props.style }}
          variant="outlined"
          value={typeof value !== "undefined" ? value : "null"}
          label="Layer"
          onChange={(e) => {
            this.onChangeHandler(i, e, type, values);
          }}
          disabled={!!disabled}
          MenuProps={{
            MenuListProps: { style: { maxHeight: "200px", overflowY: "auto" } },
          }}
        >
          {!i.colDef.required && (
            <MenuItem value={"null"}>{i.colDef.naText || "N/A"}</MenuItem>
          )}
          {values.map((j, k) => (
            <MenuItem key={k} id={k} value={k}>
              {j}
            </MenuItem>
          ))}
        </Select>
      );
    } else if (type === "radiogroup")
      element = (
        <RadioGroup row value={value.toString()}>
          {values.map(
            (i, j, l, v) => (
              (l = i.split(";")),
              (v = l[0] || i),
              (
                <FormControlLabel
                  style={{ flex: "1 1 30%" }}
                  label={l[1] || i}
                  key={j}
                  value={v}
                  disabled={disabled}
                  control={<Radio color="primary" />}
                  onClick={(e) =>
                    this.onChangeHandler(this.props.cellInfo, {
                      target: { value: v },
                    })
                  }
                />
              )
            )
          )}
        </RadioGroup>
      );
    else if (type === "combobox") {
      if (this.props.autoCompleteClear?.value) {
        this.setState({ fieldResetKey: { key: Date.now() } });
      }
      element = (
        <Autocomplete
          key={this.state.fieldResetKey.key}
          freeSolo={i.colDef.freeText}
          style={{ width: "100%" }}
          variant="outlined"
          defaultValue={value || ""}
          disabled={!!disabled}
          onInputChange={(e, v) => {
            if (!i.colDef.freeText) return;
            this.onChangeHandler(i, v, "combobox");
          }}
          onChange={(e, v) => {
            this.onChangeHandler(i, v, "combobox");
          }}
          onOpen={() => this.fetchDropdownList(i)}
          getOptionLabel={(option) =>
            i.colDef.labelKey ? option[i.colDef.labelKey] || "" : option
          }
          renderInput={(params) => <TextField {...params} variant="outlined" />}
          options={this.state.valueFromPromise || values}
          value={value}
        />
      );
    } else if (type && type.substr(0, 4) === "date") {
      let dateFormat = "dd/MM/yyyy";
      let componClass = null;
      switch (type) {
        case "date":
          componClass = KeyboardDatePicker;
          break;
        case "datetime":
        case "dateTime":
        case "datetime-local":
          componClass = KeyboardDateTimePicker;
          break;
        default:
          return <div />;
      }
      if (i.colDef.postgresSQLTimestamp) value = value && value * 1000;
      let attrs = {
        ...(i.colDef.materialUiProps || {}),
        style: { width: "100%" },
        clearable: true,
        ampm: false,
        disabled: disabled,
        variant: "dialog",
        inputVariant: "outlined",
        format: dateFormat,
        value: value,
        onChange: (e) => !isNaN(e) && this.onChangeHandler(i, e, "datetime"),
        emptyLabel: dateFormat.toUpperCase(),
      };
      element = (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          {React.createElement(componClass, attrs, null)}
        </MuiPickersUtilsProvider>
      );
    } else if (type === "list") {
      if (!value) value = [];
      if (!Array.isArray(value)) value = value.split(i.colDef.separator);
      element = (
        <Autocomplete
          multiple
          disableClearable
          options={[]}
          value={value}
          freeSolo
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                variant="outlined"
                label={option}
                {...getTagProps({ index })}
              />
            ))
          }
          onChange={(evt, newV) => this.onChangeHandler(i, newV, "list")}
          onBlur={(evt) => {
            var newValue = evt.target.value;
            newValue = newValue.trim();
            if (!!newValue)
              this.onChangeHandler(i, [...value, newValue], "list");
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder={
                i.colDef.customHint ||
                "Use " + i.colDef.separator + " to separate the items"
              }
            />
          )}
        />
      );
    } else {
      if (i.colDef.editRenderCell) element = i.colDef.editRenderCell(i);
      else {
        value = JSON.stringify(value);
        element = <span>{value}</span>;
      }
    }
    return (
      <div
        className={"editableGridCell "}
        style={{ width: "100%", ...this.props.style }}
      >
        <div
          className={this.props.errorLabelClasses || "error"}
          style={{ display: !!this.props.error ? "" : "none" }}
        >
          {!this.props.hideErrorAboveField &&
            (this.state.inputErrorMsg || this.props.error?.msg)}
        </div>
        {element}
      </div>
    );
  }
}

export default EditableDatagridCell;
